// Public copy selected by the product owner from the Persian legal bundle 1.4.
// Versioned content only: this module does not grant consent or enable a feature.
export const legalDocuments = {
  "terms": {
    "id": "terms",
    "title": "شرایط استفاده از حساب و خدمات",
    "version": "TERMS FA 1.4",
    "textDate": "2026-10-30",
    "language": "fa",
    "paragraphs": [
      {
        "lead": "",
        "text": "ارائه‌دهندهٔ خدمات روبه‌رو، کلینیک روانشناسی روبه‌رو به نشانی تهران، خیابان انقلاب اسلامی، کوچه بالاور، پلاک ۷، اتاق ۱۱۷ است. راه پشتیبانی، ایمیل support@roobroo.ir یا تلفن 09379287436 است."
      },
      {
        "lead": "حساب و اطلاعات شما",
        "text": "هویت و تماس خود را صحیح وارد کنید و کد ورود را حتی به پشتیبانی نگویید. اگر برای دیگری اقدام می‌کنید، سمت خود را صحیح اعلام کنید؛ حساب یا پرداخت هزینه به‌تنهایی اختیار رضایت‌دادن به‌جای دیگران ایجاد نمی‌کند."
      },
      {
        "lead": "پیشنهاد و دریافت خدمت",
        "text": "پیشنهاد با توجه به اطلاعات شما، پروندهٔ حرفه‌ای موجود، ترجیحات، قیمت و زمان‌ها تهیه می‌شود؛ تشخیص قطعی یا تضمین درمان نیست. ارائهٔ خدمت وابسته به پشتیبانی مسیر و احراز شرایط آن است."
      },
      {
        "lead": "رزرو و پرداخت",
        "text": "مبلغ، واحد پول، درمانگر و شرایط رزرو پیش از تأیید نمایش داده می‌شوند. انتخاب وقت یا پرداختِ در حال بررسی، رزرو قطعی نیست؛ وضعیت همان سفارش را پیگیری کنید. اعتبار برای درمانگر و شرایط اعلام‌شدهٔ همان خرید است."
      },
      {
        "lead": "لغو و بازگشت اعتبار",
        "text": "لغو خودکارِ جلسهٔ تأییدشده زمانی مجاز است که بیش از ۲۴ ساعت تا شروع مانده باشد و وضعیت رزرو اجازه بدهد. پس از لغو موفق، اعتبار همان جلسه برای رزرو دوباره در چارچوب بسته در دسترس است؛ این عملیات واریز بانکی یا شارژ کیف پول عمومی نیست."
      },
      {
        "lead": "تغییر زمان",
        "text": "با وجود وقت جایگزین و بیش از ۲۴ ساعت فاصله تا شروع، تغییر با همان درمانگر، بدون هزینه و حداکثر دو بار مجاز است. مهلت و تغییرهای باقی‌مانده را در همان رزرو بررسی کنید و وقت جایگزین را نهایی کنید."
      },
      {
        "lead": "رسیدگی به استثناها",
        "text": "در ۲۴ ساعت مانده به شروع یا پس از آن، یا وضعیت نامجاز، لغو و تغییر خودکار ممکن نیست. برای غیبت، اختلال، استثنا یا بازپرداخت بانکی از پشتیبانی بررسی بخواهید؛ درخواست، تضمین جبران یا واریز نیست و نتیجه پس از بررسی اعلام می‌شود."
      },
      {
        "lead": "رضایت و ورود",
        "text": "رضایت و آمادگی پیش از ورود بررسی می‌شوند؛ تأیید رزرو معادل ثبت رضایت نیست. نپذیرفتن یا پس‌گرفتن رضایت، خودکار رزرو را لغو یا پول و اعتبار را برنمی‌گرداند. رسیدگی مالی جداست."
      },
      {
        "lead": "تغییر درمانگر و شکایت",
        "text": "می‌توانید درخواست تغییر درمانگر یا شکایت ثبت کنید؛ زمان معرفی، وجود جایگزین و انتقال اعتبار تضمین خودکار ندارد. شکایت حرفه‌ای از مسیر کیفیت و با دسترسی افراد مجاز بررسی می‌شود."
      },
      {
        "lead": "ارتباط و حریم خصوصی",
        "text": "ساعت پشتیبانی همه‌روزه از ۹ صبح تا ۱۸ عصر به وقت تهران است. اطلاعات کارت، رمز یا دادهٔ غیرضروری دیگران را نفرستید. آزار، تهدید، جعل هویت، دسترسی غیرمجاز و ضبط یا انتشار اطلاعات دیگران بدون رضایت و مجوز لازم مجاز نیست."
      },
      {
        "lead": "نسخهٔ شرایط",
        "text": "نسخه و تاریخ شروع استفاده در محل انتشار درج می‌شود. شرایط حساب و حریم خصوصی را بخوانید؛ پذیرش آن‌ها جای رضایت درمان را نمی‌گیرد."
      }
    ],
    "acknowledgment": "شرایط استفاده و اطلاعیهٔ حریم خصوصی روبه‌رو را خوانده‌ام؛ شرایط استفاده را می‌پذیرم و از شیوهٔ پردازش داده‌ها اطلاع دارم."
  },
  "privacy": {
    "id": "privacy",
    "title": "اطلاعیهٔ حریم خصوصی مراجعان",
    "version": "PRIVACY FA 1.4",
    "textDate": "2026-10-30",
    "language": "fa",
    "paragraphs": [
      {
        "lead": "",
        "text": "این اطلاعیه دریافت و کاربرد اطلاعات توسط کلینیک روانشناسی روبه‌رو را توضیح می‌دهد. برای پرسش یا درخواست دربارهٔ داده‌های خود از ایمیل support@roobroo.ir اقدام کنید."
      },
      {
        "lead": "اطلاعات دریافت‌شده",
        "text": "حساب و تماس، اطلاعات مراجع و نقش همراهان، پاسخ‌های مسیر و ایمنی، ترجیحات، سوابق رزرو و خرید و وضعیت پرداخت، پیام‌های پشتیبانی و پاسخ فرم‌های روند در بخش‌های مورد استفاده ثبت می‌شوند. برای امنیت و پیگیری، زمان، شناسهٔ حساب و اطلاعات فنی مانند نشانی اینترنتی یا مرورگر نیز ممکن است ثبت شود."
      },
      {
        "lead": "هدف پردازش",
        "text": "اطلاعات برای مدیریت حساب، بررسی امکان خدمت، پیشنهاد درمانگر، رزرو، ارتباط جلسه، پیگیری مالی، پشتیبانی و مشاهدهٔ روند استفاده می‌شوند. پاسخ فرم‌ها تشخیص قطعی نیستند. این اطلاعیه کاربرد توضیح‌داده‌نشده‌ای را مجاز اعلام نمی‌کند."
      },
      {
        "lead": "دسترسی افراد مجاز",
        "text": "دسترسی با توجه به نقش و نیاز خدمت کنترل می‌شود. درمانگر، پشتیبانی، مالی و مدیران مجاز برای وظایف خود به اطلاعات لازم دسترسی دارند. دسترسی فنی کنترل‌شده برای نگهداری، امنیت یا رفع اشکال نیز ممکن است وجود داشته باشد."
      },
      {
        "lead": "ارائه‌دهندگان همکار",
        "text": "برای پرداخت، ارسال پیام و ارتباط تصویری، اطلاعات لازم در اختیار ارائه‌دهندهٔ همان خدمت قرار می‌گیرد. اطلاعات کارت و رمز را فقط در صفحهٔ معتبر درگاه وارد کنید و در پیام‌ها نفرستید. ارائه‌دهندگان ارتباط تصویری ممکن است اطلاعات فنی اتصال را طبق اطلاعیهٔ خود پردازش کنند."
      },
      {
        "lead": "جلسه و حریم خصوصی محیط",
        "text": "پیش از جلسه محیط مناسب فراهم کنید و حضور اشخاص دیگر را اعلام کنید. ضبط یا انتشار جلسه و اطلاعات دیگران بدون هماهنگی، رضایت و مجوز لازم مجاز نیست. هر تصمیم دربارهٔ ضبط یا استفادهٔ جداگانه از محتوا باید پیش از انجام روشن شود."
      },
      {
        "lead": "مرورگر و کوکی",
        "text": "شناسه‌های مورد نیاز ورود و کارکرد حساب ممکن است در مرورگر شما ذخیره شوند. ابزارهای آمارگیری یا تبلیغاتی و انتخاب‌های مربوط، در صورت استفاده، باید در فهرست سرویس‌های فعال توضیح داده شوند؛ پذیرش رضایت درمان به‌تنهایی رضایت مستقل برای چنین کاربردی نیست."
      },
      {
        "lead": "نگهداری و نسخهٔ پشتیبان",
        "text": "در نسخهٔ فعلی، حذف خودکار زمان‌دار برای همهٔ داده‌ها اجرا نمی‌شود. اطلاعات حساب، پرونده و سوابق مالی برای ارائهٔ خدمت و پیگیری سوابق نگهداری می‌شوند و درخواست حذف جدا بررسی می‌شود. توقف پرسش‌نامه، خروج از حساب یا لغو جلسه به‌معنی حذف اطلاعات قبلی نیست."
      },
      {
        "lead": "درخواست بررسی اصلاح یا حذف",
        "text": "با راه تماس ثبت‌شدهٔ خود به ایمیل support@roobroo.ir پیام بدهید و موضوع را مشخص کنید. پیش از اقدام، هویت و دامنهٔ درخواست بررسی می‌شوند. دریافت درخواست به معنی حذف قطعی یا فوری نیست؛ نتیجه و دلیل هر محدودیت نگهداری در پاسخ توضیح داده می‌شود. حذف از پایگاه اصلی، حذف هم‌زمان نسخه‌های پشتیبان یا نسخه‌های قبلاً دریافت‌شده با مجوز را تضمین نمی‌کند."
      },
      {
        "lead": "حدود محرمانگی",
        "text": "اطلاعات درمانی برای عموم منتشر نمی‌شود. افشای استثنایی، از جمله در خطر جدی یا الزام قانونی، تابع قواعد معتبر و حداقل اطلاعات لازم است. حدود مرتبط در رضایت درمان و گفت‌وگو با درمانگر توضیح داده می‌شوند."
      }
    ]
  },
  "safety": {
    "id": "safety",
    "title": "راهنمای ایمنی و کمک فوری",
    "version": "SAFETY DIRECTORY FA 1.4",
    "textDate": "2026-10-30",
    "language": "fa",
    "paragraphs": [
      {
        "lead": "",
        "text": "اگر در خطر فوری هستی یا فکر می‌کنی ممکن است همین حالا به خودت یا دیگری آسیب بزنی، با خدمات اضطراری محل خودت تماس بگیر یا به نزدیک‌ترین مرکز اورژانس مراجعه کن. اگر برایت امن و ممکن است، از فردی قابل اعتماد بخواه کنارت بماند. منتظر معرفی درمانگر یا پاسخ پیام در روبه‌رو نمان."
      },
      {
        "lead": "",
        "text": "روبه‌رو سرویس اورژانسی یا سامانهٔ پایش دائمی نیست. پیام به پشتیبانی یا درمانگر، درخواست رسیدگی فوری بالینی محسوب نمی‌شود. در فهرست زیر، کاربرد و ساعت واقعی هر خدمت را بررسی کن؛ در دسترس‌بودن صفحه به معنی شبانه‌روزی بودن همهٔ خدمات نیست."
      },
      {
        "lead": "",
        "text": "با توجه به اطلاعات این مسیر، فعلاً امکان ادامهٔ رزرو عادی فراهم نیست. این پیام تشخیص قطعی دربارهٔ وضعیت تو نیست. راهنمای کمک مناسب محل خودت را ببین. برای سؤال دربارهٔ حساب یا مسیر دریافت خدمت از پشتیبانی کمک بگیر؛ پشتیبانی جای خدمات کمک فوری را نمی‌گیرد."
      },
      {
        "lead": "",
        "text": "در حال حاضر برای ترکیب موضوع، شرایط و زمان‌های انتخابی تو گزینهٔ قابل رزرو پیدا نکردیم. این نتیجه به معنی ناممکن‌بودن دریافت کمک نیست. اگر مایل هستی زمان‌ها یا ترجیحاتت را بازبینی کن یا دربارهٔ گزینه‌های موجود از پشتیبانی راهنمایی بگیر. معرفی گزینهٔ تازه در زمان مشخص تضمین نمی‌شود."
      }
    ]
  },
  "private-letter": {
    "id": "private-letter",
    "title": "نامهٔ خصوصی برای خود مراجع",
    "version": "PRIVATE LETTER FA 1.4",
    "textDate": "2026-10-30",
    "language": "fa",
    "paragraphs": [
      {
        "lead": "",
        "text": "اگر مایل هستی، پیش از شروع جلسهٔ اول می‌توانی نامه‌ای برای خودت بنویسی؛ مثلاً دربارهٔ چیزی که می‌خواهی از این مسیر به یاد داشته باشی. نوشتن آن اختیاری است و می‌توانی بدون نامه ادامه بدهی. ننوشتن یا حذف نامه، مانع پیشنهاد درمانگر، آمادگی یا ورود به جلسه نمی‌شود."
      },
      {
        "lead": "",
        "text": "این نامه برای خود توست و برای دریافت پاسخ به درمانگر ارسال نمی‌شود. پس از انتخاب «ثبت و قفل‌کردن نامه»، متن ذخیره و قفل می‌شود و امکان ویرایش ندارد. پیش از ثبت، نوشته‌ات را مرور کن. نامهٔ ذخیره‌شده در حساب خودت قابل مشاهده است و لازم نیست برای خواندنش منتظر پایان درمان یا تاریخ مشخصی بمانی."
      },
      {
        "lead": "",
        "text": "محتوا در نماهای معمول درمانگر و کارکنان نمایش داده نمی‌شود. این ویژگی، وعدهٔ نبود هرگونه دسترسی فنی یا رمزنگاری سرتاسری نیست. از نامه برای درخواست کمک فوری استفاده نکن؛ ثبت آن باعث پایش خودکار خطر، هشدار به کشیک یا تماس درمانگر نمی‌شود."
      },
      {
        "lead": "",
        "text": "تا زمانی که گزینهٔ حذف برای نامهٔ متنی در حساب فعال است، می‌توانی متن را حذف کنی. حذف متن، سابقهٔ بدون محتوای ثبت یا حذف را پاک نمی‌کند و حذف هم‌زمان نسخه‌های پشتیبان را تضمین نمی‌کند. دربارهٔ داده‌های خود از ایمیل support@roobroo.ir پیگیری کن."
      },
      {
        "lead": "",
        "text": "در این نسخه، حذف خودکار زمان‌دار، ثبت صوت و تحویل ویژهٔ زمان‌بندی‌شده فعال نیستند. برای هر قابلیت تازه باید شرایط مربوط پیش از استفاده توضیح داده شود."
      }
    ],
    "acknowledgment": "می‌دانم این نامه برای خودم است، پس از ثبت قابل ویرایش نیست، در حساب خودم دیده می‌شود و شرایط نگهداری و حذف آن را خوانده‌ام؛ می‌خواهم متن ثبت و قفل شود."
  }
}

export function getLegalDocument(id) {
  return Object.prototype.hasOwnProperty.call(legalDocuments, id) ? legalDocuments[id] : null
}
